var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subscription-container"},[_c('div',{staticClass:"subscription-container__details"},[_vm._t("details"),_c('div',{staticClass:"subscription-container__footer"},[_vm._t("button")],2),_c('div',[_vm._t("help")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }